const PROJECT_URLS = { 
    GET_ALL: "/project/get_all",
    UPDATE: "/project/update",
    INSERT: "/project/insert",
    GET_ONE: "/project/get_one",
    DELETE: "/project/delete_one",

    GET_TASK_BY_PROJ: "/project/get_tasks_by_project",
  };
  
  
  export {
    PROJECT_URLS
  };